import React from 'react';
import { Routes, Route, Navigate  } from "react-router-dom";
import './tailwind.css'; 
import Applications from './pages/Applications';
import EditApplication from './pages/EditApplication';
import EditStudent from './pages/EditStudent';
import Courses from './pages/Courses';
import AddCourse from './pages/AddCourse';
import Dashboard from './pages/Dashboard';
import '@progress/kendo-theme-default/dist/all.css';

const AdminApp = () => (
    <Routes>
        <Route exact path="/" element={window.defaultRoutePath ? <Navigate to={window.defaultRoutePath} replace={true} /> : <Dashboard />} />
        <Route path="applications" element={<Applications />} />
        <Route path="application/edit/:applicationId" element={<EditApplication />} />
        <Route path="application/edit/:applicationId/:section" element={<EditApplication />} />
        <Route path="courses" element={<Courses />} />
        <Route path="course/add" element={<AddCourse />} />
        <Route path="course/add/:section" element={<AddCourse />} />
        <Route path="course/edit/:courseId" element={<AddCourse />} />
        <Route path="course/edit/:courseId/:section" element={<AddCourse />} />
        <Route path="course/:courseId/students/:studentId/" element={<EditStudent />} />
        <Route path="course/:courseId/students/:studentId/:section" element={<EditStudent />} />
    </Routes>
);

export default AdminApp;